import React from 'react';
import { useDispatch } from 'react-redux';
// images
import Lock from '@/components/ui/new-icons/Lock';
// styles
import styles from './styles.module.scss';
// types
import { IAccountRegistrationEnum } from '@/models/account/types';

const InviteOnlyNoAccessSection = ({ currentUser, onPopup = false }) => {
  const dispatch = useDispatch();

  const handleBackButton = () => {
    // If user is logged in, log them out (This case would happen if a user was already logged in
    //  from another session and goes to this landing page but does not have access to the event.)
    if (currentUser && currentUser.accountId) {
      // Logout this account since it does not have access to the event
      dispatch({
        type: 'account/logoutNoRedirect',
      });
    }

    // Set the registration step back to login method
    dispatch({
      type: 'account/setRegistrationStep',
      payload: { registrationStep: IAccountRegistrationEnum.LOGIN_METHOD },
    });
  };

  // The handler for a click on the back arrow
  const handleBackClick = () => {
    handleBackButton();
  };

  // The handler for the Enter key while focused on back arrow button
  const handleEnterKey = event => {
    if (event.key === 'Enter') {
      handleBackButton();
    }
  };

  return (
    <>
      <div className={onPopup ? styles.outerSectionContainerPopUp : styles.outerSectionContainer}>
        <div className={styles.innerSectionContainer}>
          <Lock color={'black'} />
        </div>
      </div>
      <div className={styles.mainHeading}>Private Event</div>
      <div className={styles.heading}>
        You do not have access to this <br /> <span className={styles.headerBold}>Invite only event</span>
      </div>
    </>
  );
};
export default InviteOnlyNoAccessSection;
